<div class="video-questionnaire-container">
  <!-- Main Content Area -->

  <!-- Loading State -->
  <div *ngIf="state === 'loading'" class="loading-container">
    <div class="spinner-y"></div>
    <div class="loading-text">Loading questionnaire...</div>
  </div>

  <div *ngIf="state === 'error'" class="error-message message">
    {{ errorMsg }}
  </div>
  <div
    class="message"
    *ngIf="state === 'intro'"
    style="padding: 20px; text-align: center; position: relative; top: -22px"
  >
    <div class="greeting">Hello, {{ firstName }}!</div>
    <div style="font-size: 18px; display: table; margin: 12px auto">
      Thank you for joining the INWEDIO questionnaire
    </div>

    <div (click)="setState('main')" class="lets-start-button">Let's start!</div>
  </div>

  <div *ngIf="state === 'main'" style="width: 100%">
    <div
      *ngIf="mainIntro"
      class="message"
      style="font-size: 20px; text-align: center; line-height: 26px"
    >
      Let's see the sample videos...
    </div>
    <div *ngIf="!mainIntro" class="second video-body">
      <!-- Video Player (Left) -->

      <div class="video-lane">
        <div class="section-title">
          {{ activeSection.title }}
        </div>
        <div class="video-container">
          <video
            #firstVideo
            [muted]="true"
            [src]="currentVideoUrl"
            playsinline
            class="video-player"
            (ended)="onVideoEnded()"
          ></video>

          <!-- [style.display]="firstIsShown ? 'block' : 'none'" -->
          <!-- <video
          #secondVideo
          muted
          playsinline
          [src]="secondUrl"
          preload="auto"
          [style.display]="secondIsShown ? 'block' : 'none'"
          (ended)="onVideoEnded()"
          ></video> -->
        </div>

        <div
          class="video-indicators"
          *ngIf="activeSection.videoUrls?.length > 1"
        >
          <button
            *ngFor="let key of currentVideoUrls; let i = index"
            class="video-indicator"
            [class.active]="isVideoActive(key)"
            (click)="goToVideo(key)"
            [attr.aria-label]="'Go to video ' + (i + 1)"
          >
            <span class="indicator-circle"></span>
          </button>
        </div>
      </div>

      <div class="answers-lane" style="display: flex; flex-direction: column">
        <div class="section-title">
          <!-- this is just a placeholder -->
        </div>
        <div class="answers-section" [class.fading]="answersFading">
          <div class="answers-section-inner">
            <div
              class="answer"
              (click)="_selectOption(0)"
              [class.selected]="answers[activeSectionIndex] === 0"
            >
              <nw-icon type="thumb_up" [outlined]="true" [size]="18"></nw-icon>
              <div>
                I like it and I can imagine posting such a video for our company
              </div>
            </div>
            <div
              class="answer"
              [class.selected]="answers[activeSectionIndex] === 1"
              (click)="_selectOption(1)"
            >
              <nw-icon
                type="sentiment_neutral"
                [outlined]="true"
                [size]="18"
              ></nw-icon>
              Cool, but I don't really see the use-case yet
            </div>
            <div
              class="answer"
              [class.selected]="answers[activeSectionIndex] === 2"
              (click)="_selectOption(2)"
            >
              <nw-icon
                type="thumb_down"
                [outlined]="true"
                [size]="18"
              ></nw-icon>
              <div>Hmmm, I rather don't like it</div>
            </div>
            <div
              class="answer"
              *ngIf="!showFeedbackInput"
              (click)="toggleFeedbackInput()"
            >
              <nw-icon
                type="text_fields"
                [outlined]="true"
                [size]="18"
              ></nw-icon>
              <div>Let me write my own feedback</div>
            </div>
            <textarea
              *ngIf="showFeedbackInput"
              #feedbackTextarea
              class="answer feedback-textarea"
              [(ngModel)]="feedbackText"
              placeholder="Write your feedback here..."
              (blur)="showFeedbackInput = feedbackText.length > 0"
              rows="3"
            ></textarea>
          </div>

          <!-- Custom feedback button/textarea -->
          <div>
            <div
              class="next-button"
              [class.disabled]="!isNextEnabled"
              (click)="isNextEnabled ? nextQuestion() : null"
            >
              Next
            </div>
          </div>
        </div>
        <div class="footer-placeholder"></div>
      </div>
      <!-- </div> -->
      <!-- Empty State -->
      <!-- <div class="empty-state" *ngIf="sections.length === 0">
        <p>No sections available</p>
      </div> -->

      <!-- Section Selector Footer -->
      <!-- <div class="section-footer" *ngIf="sections.length > 0">
        <div class="section-indicators">
          <button
            *ngFor="let section of sections; let i = index"
            class="section-indicator"
            [class.active]="isSectionActive(i)"
            (click)="goToSection(i)"
            [attr.aria-label]="'Go to section ' + (i + 1)"
          >
            <span class="indicator-circle"></span>
          </button>
        </div>
      </div> -->
    </div>
  </div>
  <div
    *ngIf="state === 'use-cases'"
    style="padding: 20px; text-align: center; position: relative; top: -42px"
  >
    <div *ngIf="messageSection == 0" class="message-l">
      We appereciate your feedback!
    </div>
    <div
      *ngIf="messageSection == 1"
      class="message-l final-section"
      style="line-height: 34px"
      [innerHTML]="finallyMessage"
    ></div>
    <div *ngIf="messageSection == 2" class="message">
      <app-new-project-component
        [customToken]="customToken"
        [questionnaire]="questionnaire"
        (finished)="useCaseFinished()"
      ></app-new-project-component>
    </div>
  </div>
  <div
    *ngIf="state === 'finished'"
    class="message thanks-message"
    style="display: flex"
  >
    <div
      style="font-size: 22px; text-align: center"
      [innerHTML]="
        isMobile
          ? 'Thank you very much <br/> for your time!'
          : 'Thank you very much for your time!'
      "
    ></div>
    <nw-icon
      *ngIf="!isMobile"
      type="thumbs_up_double"
      [size]="32"
      [outlined]="true"
    ></nw-icon>
  </div>
</div>
